import { Component, Input } from '@angular/core';

import { GridColumn, GridItem } from '../../grid-control.model';

@Component({
  selector: 'sd-grid-desktop-column-view',
  templateUrl: './grid-desktop-column-view.component.html',
  styleUrls: ['./grid-desktop-column-view.component.scss']
})
export class GridDesktopColumnViewComponent {
  @Input() column: GridColumn;
  @Input() item: GridItem;
  constructor(
  ) { }
}
